<template>
  <div class="card h-100 tags-trends-widget">
    <div class="card-header">
      <h4 class="card-title">
        {{ widgetTitle }}
      </h4>
    </div>
    <div class="card-body pb-lg-20">
      <TagTrendsDetails
        :id="id"
        :tags="tags"
        :trendTags="trendTags"
        :chartType="chartType"
      />
    </div>
  </div>
</template>

<script>
import commonWidgetProps from '@/components/mixins/common-widget-props'
import { requestTypes } from '@/constants/request-types'
import TagTrendsDetails from '@/components/shared/TagTrendsDetails.vue'
import { errorTypes } from '@/constants/error-types'

export const tagsTrendsWidgetInformation = ({ colData }) => {
  const tags = colData.tags.reduce((res, tagName) => {
    res[tagName] = {}
    return res
  }, {})
  return {
    requests: {
      [requestTypes.SURVEY_DETAILS]: {},
      [requestTypes.TAGS]: { filter: tags },
      [requestTypes.TREND_TAGS]: { filter: tags }
    }
  }
}

export const tagsTrendsWidgetSkeleton = () => {
  return {
    header: {
      height: 2
    },
    body: [
      {
        cols: [{ height: 2 }]
      },
      {
        cols: [{ height: 10 }]
      }
    ]
  }
}

const TagsTrendsWidget = {
  name: 'TagsTrendsWidget',
  components: {
    TagTrendsDetails
  },
  mixins: [commonWidgetProps],
  props: {
    surveyDetails: {
      type: Object,
      default: () => {}
    },
    tags: {
      type: Object,
      default: () => {}
    },
    trendTags: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  mounted() {
    if (!this.anyTagHasValue) {
      this.deregisterWidget({
        id: this.id,
        info: {
          reason: errorTypes.NOT_ENOUGH_DATA,
          hideWidget: true,
          hideWidgetWhenNoSurveyResults: true
        },
        groupName: this.selectedGroupName
      })
    }
  },
  computed: {
    chartType() {
      if (this.data.tags.length === 1) {
        return 'single'
      } else if (this.data.tags.length === 2) {
        return 'double'
      } else {
        return 'many'
      }
    },
    anyTagHasValue() {
      return Object.values(this.trendTags || {}).find(
        (t) => t.surveyName === this.surveyName && t.averages?.length > 0
      )
    },
    firstTag() {
      return this.data.tags[0]
    },
    secondTag() {
      return this.data.tags[1]
    },
    tagNamesForTitle() {
      let tagNames
      if (this.chartType === 'single' && this.firstTag) {
        tagNames = this.tags[this.firstTag]?.messages
          ? this.$tr(this.tags[this.firstTag].messages, 'title')
          : null
      } else if (
        this.chartType === 'double' &&
        this.firstTag &&
        this.secondTag
      ) {
        const tag1 = this.tags[this.firstTag]?.messages
          ? this.$tr(this.tags[this.firstTag].messages, 'title')
          : null
        const tag2 = this.tags[this.secondTag]?.messages
          ? this.$tr(this.tags[this.secondTag].messages, 'title').toLowerCase()
          : null
        tagNames = this.$t('widgetTagsTrends.twoTags', { tag1, tag2 })
      } else {
        tagNames = this.data.tags
          .filter((tagName) => this.tags[tagName].messages)
          .map((tagName) => this.$tr(this.tags[tagName].messages, 'title'))
          .join(', ')
      }
      return tagNames
    },
    widgetTitle() {
      return this.$t('widgetTagsTrends.title', {
        tagNames: this.tagNamesForTitle
      })
    }
  }
}

export default TagsTrendsWidget
</script>

<style lang="scss"></style>
